import { getDatabase } from "firebase/database"
import { initializeApp } from "firebase/app"

const firebaseConfig = {
  apiKey: "AIzaSyAmo8ZsxogXAEc2oRlEg8kqy2HhMTOHfE0",
  authDomain: "careful-form-381613.firebaseapp.com",
  databaseURL:
    "https://careful-form-381613-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "careful-form-381613",
  storageBucket: "careful-form-381613.firebasestorage.app",
  messagingSenderId: "1085055399421",
  appId: "1:1085055399421:web:c52d37a8f1ce1df8c0d594",
  measurementId: "G-1G07M08L56",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const database = getDatabase(app, "https://dio-db.firebaseio.com/")
